/*
This component exists because of the duality of LayoutFlex and LayoutAwesome.

But, since LayoutAwesome has been removed from the application,
it's almost an alias of LayoutFlex.

We keep this component so in the future any other layout is added
it'll be easier to display one layout or another.
*/

import React from 'react';
import LayoutFlex from './LayoutFlex';

const Layout = (props) => {
	let new_props = {...props};
	if(new_props.page == undefined) new_props.page = 'landing';

	return (
		<LayoutFlex
			{...new_props}
		>{props.children}</LayoutFlex>
	);
}

export default Layout;